import React from 'react';
import screenfull from 'screenfull';

import {connectToLightProjects} from 'App/features/searchEntities/lightProjects/lightProjectsSlice';
import {PluAutoNotificationsContainer} from 'Features/plu_autos/notifications/plu_auto_notifications_portal';

import ContentView from './content_view.js';

class ContentContainer extends React.Component {
  state = {
    map2DConfiguration: null,
    map3DConfiguration: null,
    isRequesting: false,
    inseeCodeFilter: null,
    focusedParcel: null,
    focusedProject: null,
    focusedLandUnit: null,
    focusedTransaction: null,
    focusedLead: null,
    focusedCity: null,
    focusedAddress: null,
    isExperimentalFeaturesViewable: false,
    isFullScreen: false,
    parcelInfoBox: null,
  };

  componentDidUpdate(prevProps) {
    // This component is root for several pages (not only projects list),
    // so handleRequestingStatusChange is drilled to a lot of components
    // and we can delete it only when we move all that components to
    // redux and connect their isRequesting for ContentContainer
    const {isLightProjectsRequesting} = this.props;
    if (
      prevProps.isLightProjectsRequesting !==
      this.props.isLightProjectsRequesting
    ) {
      this.handleRequestingStatusChange(isLightProjectsRequesting);
    }
  }

  contentViewReference = React.createRef();

  getPosition = () => {
    return this.contentViewReference.current.getPosition();
  };

  getRadius = () => {
    return this.contentViewReference.current.getRadius();
  };

  onAddressSelect(address) {
    return this.contentViewReference.current.onAddressSelect(address);
  }

  handleParcelFocus = parcelFeature => {
    this.setState({
      focusedParcel: parcelFeature,
      focusedProject: null,
      focusedLandUnit: null,
    });
  };

  handleProjectFocus = project => {
    this.setState({
      focusedParcel: null,
      focusedProject: project,
      focusedLandUnit: null,
    });
  };

  handleLandUnitFocus = landUnit => {
    this.setState({
      focusedParcel: null,
      focusedProject: null,
      focusedLandUnit: landUnit,
    });
  };

  handleCityChanged = cityFeature => {
    if (cityFeature.id !== this.state.inseeCodeFilter) {
      this.setState({
        inseeCodeFilter: cityFeature.id,
      });
    }
  };

  handleFullscreenChange = isFullscreen => {
    this.setState({isFullscreen});
  };

  handleMapConfigurationChange = newConfiguration => {
    const {
      isExperimentalFeaturesViewable,
      map2DConfiguration = {},
      map3DConfiguration = null,
      parcelInfoBox,
    } = newConfiguration;

    if (
      map2DConfiguration.leads &&
      !map2DConfiguration.leads.length &&
      this.state.focusedLead
    ) {
      map2DConfiguration.leads = [this.state.focusedLead];
    }

    const newMerged2DConfiguration = {
      onProjectFocused: map2DConfiguration.handleProjectFocus
        ? this.handleProjectFocus
        : null,
      onCityChanged: map2DConfiguration.handleCityChanged
        ? this.handleCityChanged
        : null,
      onParcelFocused: map2DConfiguration.handleParcelFocus
        ? this.handleParcelFocus
        : null,
      onLandUnitFocused: map2DConfiguration.handleLandUnitFocus
        ? this.handleLandUnitFocus
        : null,
      parcels: [],
      landUnits: [],
      projects: [],
      leads: [],
      ...newConfiguration.map2DConfiguration,
    };

    this.setState({
      isExperimentalFeaturesViewable,
      map2DConfiguration: newMerged2DConfiguration,
      map3DConfiguration,
      parcelInfoBox,
    });
  };

  handleRequestingStatusChange = isRequesting => {
    this.setState({isRequesting});
  };

  handleItemsChanged = data => {
    const {map2DConfiguration, map3DConfiguration} = data;

    this.setState(previousState => {
      const newMap3DConfiguration = {
        ...previousState.map3DConfiguration,
        ...map3DConfiguration,
      };

      return {
        map2DConfiguration: {
          ...previousState.map2DConfiguration,
          ...map2DConfiguration,
        },
        map3DConfiguration: Object.entries(newMap3DConfiguration).length
          ? newMap3DConfiguration
          : null,
      };
    });
  };

  handleFocusedItemChanged = data => {
    this.setState({...data});
  };

  handleAutoBuildrClick = () => {
    this.contentViewReference.current.handleAutoBuildrClick();
  };

  handleShadowProjectPublished = callback => {
    this.contentViewReference.current.handleShadowProjectPublished(callback);
  };

  render() {
    const contentViewProps = {
      map2DConfiguration: this.state.map2DConfiguration,
      map3DConfiguration: this.state.map3DConfiguration,
      isRequesting: this.state.isRequesting,
      onRequestingStatusChange: this.handleRequestingStatusChange,
      inseeCodeFilter: this.state.inseeCodeFilter,
      focusedParcel: this.state.focusedParcel,
      focusedProject: this.state.focusedProject,
      focusedLandUnit: this.state.focusedLandUnit,
      focusedTransaction: this.state.focusedTransaction,
      focusedLead: this.state.focusedLead,
      focusedCity: this.state.focusedCity,
      focusedAddress: this.state.focusedAddress,
      onItemsChanged: this.handleItemsChanged,
      onFocusItemsChanged: this.handleFocusedItemChanged,
      onMapConfigurationChange: this.handleMapConfigurationChange,
      isExperimentalFeaturesViewable: this.state.isExperimentalFeaturesViewable,
      onFullScreenChange: this.handleFullscreenChange,
      parcelInfoBox: this.state.parcelInfoBox,
      onAutoBuildrClick: this.handleAutoBuildrClick,
      onShadowProjectPublished: this.handleShadowProjectPublished,
      isFullscreen: screenfull.isFullscreen,
    };

    return (
      <>
        <PluAutoNotificationsContainer />
        <ContentView ref={this.contentViewReference} {...contentViewProps}>
          {this.props.children}
        </ContentView>
      </>
    );
  }
}

export default connectToLightProjects(ContentContainer);
